const fillZeros = (number, length) => {
  var pad = new Array(1 + length).join(0);
  return (pad + number).slice(-pad.length);
};

export default fillZeros;
